// region Imports
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import { Translate, I18n } from "react-redux-i18n";
import Constants from "../../AppConstants/Constants";
import Utilities from "../../Helpers/Utilities";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/index";
import { faHome, faShippingFast, faBarcode, faCalendarAlt, faDollarSign } from "@fortawesome/free-solid-svg-icons/index";
import Layout from "../../Layouts/LayoutMain";
import { logout } from "../../Store/Account/Actions";
import { resetOrderConfirmation } from "../../Store/Checkout/Actions";
import { toggleBlockingStatus } from "../../Store/Status/Actions";
import { ContentContainer } from "../../Components/Common/ContentContainer";
import { PageTitle } from "../../Components/Common/PageTitle";
// endregion

// region Styles
const Bold = styled.span`
    font-weight: bold;
`;

const IconContainer = styled.div`
    font-size: 14pt;
`;

const Icon = styled(FontAwesomeIcon)`
    line-height: 1.85714286em;
`;

const CustomRow = styled.div`
    // Small devices (landscape phones, less than 768px)
    @media (max-width: 767.98px) {
        margin-left: 0;
        margin-right: 0;
    }
`;

const StationRow = styled.div`
    margin-top: 25px;

    // Small devices (landscape phones, less than 768px)
    @media (max-width: 767.98px) {
        margin-left: 0;
        margin-right: 0;
    }
`;

const PrintReceiptBtn = styled.button`
    // Extra small devices (portrait phones, less than 576px)
    @media (max-width: 575.98px) {
        width: 100%;
    }
    
    // Small devices (landscape phones, 576px and up)
    @media (min-width: 576px) {
        width: 150px;
    }
`;

const AddressContainer = styled.div`
    color: #425065;
    
    // Medium devices (tablets, 768px and up)
    @media (min-width: 768px) {
        min-height: 370px;
    }
    
    // Large devices (desktops, 992px and up)
    @media (min-width: 992px) {
        min-height: 410px;
    }
`;

const AddressTitleContainer = styled.div`
    font-size: 12pt;
    margin-bottom: 20px;
    
    // Small devices (landscape phones, less than 768px)
    @media (max-width: 767.98px) {
        margin-left: 0;
        margin-right: 0;
    }
`;

const AddressContentContainer = styled.div`
    font-size: 11pt;
    margin-bottom: 20px;
    
    // Small devices (landscape phones, less than 768px)
    @media (max-width: 767.98px) {
        margin-left: 0;
        margin-right: 0;
    }
`;

const AddressP = styled.p`
    color: #727e8d;
    margin-bottom: 0;
`;

const CustomerEmail = styled(AddressP)`
    //cursor: pointer;
    color: #38a7c6;
    font-weight: bold;
`;

const PaymentContainer = styled.div`
    font-size: 11pt;
    
    // Small devices (landscape phones, less than 768px)
    @media (max-width: 767.98px) {
        margin-left: 0;
        margin-right: 0;
    }
`;

const InvoiceSummaryContainer = styled.div`
    color: #425065;
    font-size: 11pt;
    
    // Extra small devices (portrait phones, less than 576px)
    @media (max-width: 575.98px) {        
        .col-sm-4:not(:last-child) & {
            margin-bottom: 20px;
        }
    }
    
    // Small devices (landscape phones, 576px and up)
    @media (max-width: 767.98px) {
        margin-left: 0;
        margin-right: 0;
        text-align: center;
    }
`;

const Table = styled.table`
    border-color: grey;
    border-top-width: 0;
    border-right-width: 0;
    border-bottom-width: 0;
    border-left-width: 0;
    border-radius: 6px;
    border-collapse: separate;
    border-spacing: 0;
`;

const TableHeader = styled.th`
    ${Table} & {
        background: #38a7c6;
        color: #fff;
        border-collapse: separate;
        border-spacing: 0;
        
        &:not(:last-child) {
            border-right: #dde5f1 solid 2px;
        }
    }
`;

const TableBodyRow = styled.tr`
    ${Table} & {        
        &:not(:last-child) {
            td {
                border-bottom: #dde5f1 solid 2px;
            }
        }
    }
`;

const TableBodyCell = styled.td`
    ${Table} & {
        background: rgb(239, 243, 247);
        color: #425065;
        border-collapse: separate;
        border-spacing: 0;
        
        &:not(:last-child) {
            border-right: #dde5f1 solid 2px;
        }
        
        // Extra small devices (portrait phones, less than 576px)
        @media (max-width: 575.98px) {
            &:nth-child(1) {
                width: 55%;
            }
            
            &:nth-child(2) {
                width: 10%;
            }
            
            &:nth-child(3) {
                width: 12%;
            }
            
            &:nth-child(4) {
                width: 23%;
            }
        }
        
        // Medium devices (tablets, 768px and up)
        @media (min-width: 768px) {
            &:nth-child(1) {
                width: 55%;
            }
            
            &:nth-child(2) {
                width: 15%;
            }
            
            &:nth-child(3) {
                width: 15%;
            }
            
            &:nth-child(4) {
                width: 15%;
            }
        }
    }
`;

const CurrencyCell = styled(TableBodyCell)`
    ${Table} & {
        text-align: right;
    }
`;

const MergedTableCell = styled(TableBodyCell)`
    ${Table} & {
        &:not(:last-child) {
            border-bottom: none !important;
        }
    }
`;

const MonthlyChargesHeader = styled.td`
    ${Table} & {
        background: rgb(211, 216, 220);
        color: #425065;
        font-weight: bold;
        border-collapse: separate;
        border-spacing: 0;
        padding-top: 0.2em;
        padding-bottom: 0.2em;
        
        &:not(:last-child) {
            border-right: #dde5f1 solid 2px;
        }
        
        // Extra small devices (portrait phones, less than 576px)
        @media (max-width: 575.98px) {
            &:nth-child(1) {
                width: 55%;
            }
            
            &:nth-child(2) {
                width: 10%;
            }
            
            &:nth-child(3) {
                width: 12%;
            }
            
            &:nth-child(4) {
                width: 23%;
            }
        }
        
        // Medium devices (tablets, 768px and up)
        @media (min-width: 768px) {
            &:nth-child(1) {
                width: 55%;
            }
            
            &:nth-child(2) {
                width: 15%;
            }
            
            &:nth-child(3) {
                width: 15%;
            }
            
            &:nth-child(4) {
                width: 15%;
            }
        }
    }
`;

const TotalCell = styled(TableBodyCell)`
    ${Table} & {
        background: #38a7c6;
        color: #fff;
        font-weight: bold;
    }
`;

const TotalCurrencyCell = styled(TotalCell)`
    ${Table} & {
        text-align: right;
    }
`;
// endregion

class OrderComplete extends Component {
    componentWillMount() {
        const { history, orderSummary } = this.props;

        if (!orderSummary || !orderSummary.orderDetail || orderSummary.orderDetail.id === null || orderSummary.orderDetail.id === undefined) {
            history.push(Constants.ENDPOINTS.CART);
        }
    }

    constructor(props) {
        super(props);

        this.printPdf = this.printPdf.bind(this);
    }

    printPdf(orderId) {
        const { toggleBlockingStatus } = this.props;

        toggleBlockingStatus(true);

        fetch(Utilities.buildUrl(`/Printing/GeneratePdfReport?name=PrintReceipt&orderId=${orderId}`), {
            ...Constants.FETCH_REQUEST_CONFIG,
            method: "GET",
            headers: {
                "Accept": "application/pdf"
            }
        })
            .then(response => {
                if (!response.ok) {
                    throw response;
                }

                return response.blob();
            })
            .then(data => {
                Utilities.showFile(data, "VelocitorOrderConfirmation");
                toggleBlockingStatus(false);
            })
            .catch(error => {
                if (error.status === 401 || error.status === 403) {
                    logout();
                } else if (error.redirect) {
                    window.location.href = error.url;
                } else {
                    const errorText = error.clone();
                    if (typeof error.json === "function") {
                        error.json()
                            .then(json => {
                                toggleBlockingStatus(false);
                                alert(json.value);
                            })
                            .catch(err => {
                                if (typeof errorText.text === "function") {
                                    errorText.text()
                                        .then(text => {
                                            toggleBlockingStatus(false);
                                            alert(text);
                                        })
                                        .catch(err => {
                                            toggleBlockingStatus(false);
                                            alert(I18n.t("alerts.genericError"));
                                        });
                                }
                            });
                    }
                }
            });
    }

    render() {
        const { orderSummary: { orderDetail, paymentInfo }, orderSummary: { orderDetail: { billingAddress, shippingAddress, items } }, userInfo, config: { DATA_PLANS_CATEGORY_ID }, i18n } = this.props;
        const nonRecurringItems = [];
        const recurringItems = [];

        _.each(items, i => {
            if (!i.isRecurring) {
                nonRecurringItems.push(i);
            } else {
                recurringItems.push(i);
            }
        });

        return (
            <Layout isAuthenticated={this.props.isAuthenticated} skipOrderConfirmationReset={true}>
                <ContentContainer>
                    <PageTitle title="orderConfirmation.title" style={{ paddingTop: 0 }} />

                    <div className="row justify-content-center" style={{ marginBottom: 20 }}>
                        <div className="col-lg-10">
                            <PrintReceiptBtn type="button" className="btn float-right" onClick={ () => this.printPdf(orderDetail.id)}><Translate value="orderConfirmation.printOrder" /></PrintReceiptBtn>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-md-6 col-lg-5">
                            <AddressContainer className="boxed boxed--border">
                                <AddressTitleContainer className="row">
                                    <IconContainer className="col-2 col-xl-1">
                                        <Icon icon={faHome} />
                                    </IconContainer>
                                    <div className="col-10 col-xl-11">
                                        <CustomRow className="row">
                                            <div className="col-12">
                                                <p className="text-uppercase">
                                                    <Translate value="orderConfirmation.invoiceCredentials.billing.title" />
                                                </p>
                                            </div>
                                        </CustomRow>
                                        <CustomRow className="row">
                                            <div className="col-12">
                                                <p>
                                                    <strong>{billingAddress.company}</strong>
                                                </p>
                                            </div>
                                        </CustomRow>
                                    </div>
                                </AddressTitleContainer>

                                <AddressContentContainer className="row">
                                    <div className="col-12">
                                        <AddressP>
                                            <strong>{billingAddress.firstName} {billingAddress.lastName}</strong>
                                        </AddressP>
                                        <AddressP>
                                            {billingAddress.address1}
                                        </AddressP>
                                        <AddressP>
                                            {billingAddress.city} {billingAddress.stateProvinceName} {billingAddress.zipPostalCode}
                                        </AddressP>
                                        <CustomerEmail>
                                            {billingAddress.email}
                                        </CustomerEmail>
                                        <AddressP>
                                            {billingAddress.phoneNumber}
                                        </AddressP>
                                    </div>
                                </AddressContentContainer>

                                {paymentInfo &&
                                <PaymentContainer className="row">
                                    {paymentInfo.bankAccount !== null
                                        ? <div className="col-12">
                                            <AddressP>
                                                <Bold><Translate value="orderConfirmation.invoiceCredentials.payment.paymentMethod" />: </Bold><Translate value="bankAccount.title" />
                                            </AddressP>
                                            <AddressP>
                                                <Bold><Translate value="bankAccount.accountNumber" />: </Bold>{paymentInfo.bankAccount.accountNumber}
                                            </AddressP>
                                        </div>
                                        : <div className="col-12">
                                            <AddressP>
                                                <Bold><Translate value="orderConfirmation.invoiceCredentials.payment.paymentMethod" />: </Bold><Translate value="creditCard.title" />
                                            </AddressP>
                                            <AddressP>
                                                <Bold><Translate value="creditCard.cardNumber" />: </Bold>{paymentInfo.card.number}
                                            </AddressP>
                                            <AddressP>
                                                <Bold><Translate value="creditCard.name" />: </Bold>{paymentInfo.card.name}
                                            </AddressP>
                                            <AddressP>
                                                <Bold><Translate value="creditCard.type" />: </Bold>{paymentInfo.card.cardType}
                                            </AddressP>
                                        </div>}
                                </PaymentContainer>}

                                {!paymentInfo &&
                                <PaymentContainer className="row">
                                    <div className="col-12">
                                        <AddressP>
                                            <Bold><Translate value="orderConfirmation.invoiceCredentials.payment.paymentMethod" />: </Bold><Translate value="lease.title" />
                                        </AddressP>
                                    </div>
                                </PaymentContainer>}

                            </AddressContainer>
                        </div>
                        <div className="col-md-6 col-lg-5">
                            <AddressContainer className="boxed boxed--border">
                                <AddressTitleContainer className="row">
                                    <IconContainer className="col-2 col-xl-1">
                                        <Icon icon={faShippingFast} />
                                    </IconContainer>
                                    <div className="col-10 col-xl-11">
                                        <CustomRow className="row">
                                            <div className="col-12">
                                                <p className="text-uppercase">
                                                    <Translate value="orderConfirmation.invoiceCredentials.shipping.title" />
                                                </p>
                                            </div>
                                        </CustomRow>
                                        <CustomRow className="row">
                                            <div className="col-12">
                                                <p>
                                                    <strong>{shippingAddress.company}</strong>
                                                </p>
                                            </div>
                                        </CustomRow>
                                    </div>
                                </AddressTitleContainer>

                                <AddressContentContainer className="row">
                                    <div className="col-12">
                                        <AddressP>
                                            <strong>{shippingAddress.firstName} {shippingAddress.lastName}</strong>
                                        </AddressP>
                                        <AddressP>
                                            {shippingAddress.address1}
                                        </AddressP>
                                        <AddressP>
                                            {shippingAddress.city} {shippingAddress.stateProvinceName} {shippingAddress.zipPostalCode}
                                        </AddressP>
                                        <CustomerEmail>
                                            {shippingAddress.email}
                                        </CustomerEmail>
                                        <AddressP>
                                            {shippingAddress.phoneNumber}
                                        </AddressP>
                                    </div>
                                </AddressContentContainer>

                                <CustomRow className="row">
                                    <div className="col-12">
                                        <AddressP>
                                            <Bold><Translate value="orderConfirmation.invoiceCredentials.shipping.shippingMethod" /></Bold>
                                        </AddressP>
                                        <AddressP>
                                            {orderDetail.shippingMethod}
                                        </AddressP>
                                    </div>
                                </CustomRow>

                                <StationRow className="row">
                                    <div className="col-12">
                                        <AddressP>
                                            <Bold><Translate value="cart.payment.customerAlert.station" />: </Bold>{userInfo.station ? userInfo.station : "--"}
                                        </AddressP>
                                        <AddressP>
                                            <Bold><Translate value="cart.payment.customerAlert.employeeId" />: </Bold>{userInfo.employeeId ? userInfo.employeeId : "--"}
                                        </AddressP>
                                    </div>
                                </StationRow>

                            </AddressContainer>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="boxed boxed--border">
                                <CustomRow className="row">
                                    <div className="col-sm-4">
                                        <InvoiceSummaryContainer className="row">
                                            <IconContainer className="col-md-2 offset-md-2">
                                                <Icon icon={faBarcode} />
                                            </IconContainer>
                                            <div className="col-md-8">
                                                <CustomRow className="row">
                                                    <div className="col-12">
                                                        <p className="text-capitalize">
                                                            <Translate value="orderConfirmation.invoiceSummary.orderNumber" />
                                                        </p>
                                                    </div>
                                                </CustomRow>
                                                <CustomRow className="row">
                                                    <div className="col-12">
                                                        <p>
                                                            <strong>#{orderDetail.customOrderNumber}</strong>
                                                        </p>
                                                    </div>
                                                </CustomRow>
                                            </div>
                                        </InvoiceSummaryContainer>
                                    </div>

                                    <div className="col-sm-4">
                                        <InvoiceSummaryContainer className="row">
                                            <IconContainer className="col-md-2 offset-md-2">
                                                <Icon icon={faCalendarAlt} />
                                            </IconContainer>
                                            <div className="col-md-8">
                                                <CustomRow className="row">
                                                    <div className="col-12">
                                                        <p className="text-capitalize">
                                                            <Translate value="orderConfirmation.invoiceSummary.orderDate" />
                                                        </p>
                                                    </div>
                                                </CustomRow>
                                                <CustomRow className="row">
                                                    <div className="col-12">
                                                        <p>
                                                            <strong>{I18n.l(orderDetail.createdOn, { dateFormat: "locale.date.long1" })}</strong>
                                                        </p>
                                                    </div>
                                                </CustomRow>
                                            </div>
                                        </InvoiceSummaryContainer>
                                    </div>

                                    <div className="col-sm-4">
                                        <InvoiceSummaryContainer className="row">
                                            <IconContainer className="col-md-2 offset-md-2">
                                                <Icon icon={faDollarSign} />
                                            </IconContainer>
                                            <div className="col-md-8">
                                                <CustomRow className="row">
                                                    <div className="col-12">
                                                        <p className="text-capitalize">
                                                            <Translate value="orderConfirmation.invoiceSummary.orderTotal" />
                                                        </p>
                                                    </div>
                                                </CustomRow>
                                                <CustomRow className="row">
                                                    <div className="col-12">
                                                        <p>
                                                            <strong>{orderDetail.orderTotal}</strong>
                                                        </p>
                                                    </div>
                                                </CustomRow>
                                            </div>
                                        </InvoiceSummaryContainer>
                                    </div>
                                </CustomRow>
                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10 text-center">
                            <Table>
                                <thead>
                                    <tr>
                                        <TableHeader><Translate value="orderConfirmation.items.header.description" /></TableHeader>
                                        <TableHeader><Translate value="orderConfirmation.items.header.price" /></TableHeader>
                                        <TableHeader><Translate value="orderConfirmation.items.header.quantity" /></TableHeader>
                                        <TableHeader><Translate value="orderConfirmation.items.header.total" /></TableHeader>
                                    </tr>
                                </thead>
                                <tbody>
                                    {_.map(nonRecurringItems, (item, i) =>
                                        <TableBodyRow key={i}>
                                            {item.categoryId !== DATA_PLANS_CATEGORY_ID
                                                ? <TableBodyCell className="text-left">{item.productName}<br/>SKU: ({item.sku})</TableBodyCell>
                                                : <TableBodyCell className="text-left">{item.productName}</TableBodyCell>}
                                            <CurrencyCell>{item.unitPrice}</CurrencyCell>
                                            <TableBodyCell>{item.quantity}</TableBodyCell>
                                            <CurrencyCell>{item.subTotal}</CurrencyCell>
                                        </TableBodyRow>
                                    )}

                                    <TableBodyRow>
                                        <MergedTableCell colSpan="2" className="text-left"/>
                                        <TableBodyCell><Translate value="orderConfirmation.items.footer.subTotal" /></TableBodyCell>
                                        <CurrencyCell>{orderDetail.orderSubtotal}</CurrencyCell>
                                    </TableBodyRow>
                                    <TableBodyRow>
                                        <MergedTableCell colSpan="2" className="text-left"/>
                                        <TableBodyCell><Translate value="orderConfirmation.items.footer.shipping" /></TableBodyCell>
                                        <CurrencyCell>{orderDetail.orderShipping}</CurrencyCell>
                                    </TableBodyRow>
                                    <TableBodyRow>
                                        <MergedTableCell colSpan="2" className="text-left"/>
                                        <TableBodyCell><Translate value="orderConfirmation.items.footer.fee" /></TableBodyCell>
                                        <CurrencyCell>{orderDetail.paymentMethodAdditionalFee}</CurrencyCell>
                                    </TableBodyRow>
                                    <TableBodyRow>
                                        <MergedTableCell colSpan="2" className="text-left"/>
                                        <TableBodyCell><Translate value="orderConfirmation.items.footer.taxes" /></TableBodyCell>
                                        {/* <CurrencyCell>{orderDetail.tax}</CurrencyCell> */}
                                        <TableBodyCell><Translate value="orderConfirmation.items.footer.taxStatement" /></TableBodyCell>
                                    </TableBodyRow>
                                    <TableBodyRow>
                                        <MergedTableCell colSpan="2" className="text-left"/>
                                        <TotalCell><Translate value="orderConfirmation.items.footer.total" /></TotalCell>
                                        <TotalCurrencyCell>{orderDetail.orderTotal}</TotalCurrencyCell>
                                    </TableBodyRow>

                                    {recurringItems.length > 0
                                        ? <TableBodyRow>
                                            <MonthlyChargesHeader className="text-left"><Translate value="orderConfirmation.items.header.recurring" /></MonthlyChargesHeader>
                                            <MonthlyChargesHeader/>
                                            <MonthlyChargesHeader/>
                                            <MonthlyChargesHeader/>
                                        </TableBodyRow>
                                        : ""}

                                    {recurringItems.length > 0
                                        ? _.map(recurringItems, (item, i) =>
                                            <TableBodyRow key={i}>
                                                {item.categoryId !== DATA_PLANS_CATEGORY_ID
                                                    ? <TableBodyCell className="text-left">{item.productName}<br/>SKU: ({item.sku})</TableBodyCell>
                                                    : <TableBodyCell className="text-left">{item.productName}</TableBodyCell>}
                                                <CurrencyCell>{item.unitPrice}</CurrencyCell>
                                                <TableBodyCell>{item.quantity}</TableBodyCell>
                                                <CurrencyCell>{item.subTotal}</CurrencyCell>
                                            </TableBodyRow>
                                        )
                                        : ""}

                                    {recurringItems.length > 0
                                        ? <TableBodyRow>
                                            <MergedTableCell colSpan="2" className="text-left"/>
                                            <TableBodyCell><Translate value="orderConfirmation.items.footer.recurring" /></TableBodyCell>
                                            <CurrencyCell>{orderDetail.orderRecurringTotal}</CurrencyCell>
                                        </TableBodyRow>
                                        : ""}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </ContentContainer>
            </Layout>
        );
    }
}

OrderComplete.propTypes = {
    resetOrderConfirmation: PropTypes.func,
    toggleBlockingStatus: PropTypes.func,
    logout: PropTypes.func,
    isAuthenticated: PropTypes.bool,
    i18n: PropTypes.object,
    config: PropTypes.object,
    orderSummary: PropTypes.object,
    userInfo: PropTypes.object,
    history: PropTypes.object
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        config: state.config,
        orderSummary: state.orderDetail,
        userInfo: state.userInfo
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        resetOrderConfirmation: resetOrderConfirmation,
        toggleBlockingStatus: toggleBlockingStatus,
        logout: logout
    }, dispatch)
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OrderComplete));
